import LandingPage from './LandingPage';

export default { LandingPage };



// WEBPACK FOOTER //
// ./src/components/Pages/Forms/PublicForms/index.js